"use client"

import { useUser } from "@clerk/nextjs"
import { useEffect } from "react"
import * as amplitude from "@amplitude/analytics-browser"

export const Amplitude = () => {
  const { user } = useUser()

  useEffect(() => {
    amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY ?? "", {
      userId: user?.id,
      defaultTracking: true,
    })
  }, [])

  useEffect(() => {
    amplitude.setUserId(user?.id)
  }, [user?.id])

  return null
}
